export const environment = {
  production: false,
  apiUrl: 'https://gatewayapi-dev.academy.inclub.world' // 'http://localhost:8080' //
};
